import { Box } from '@mui/material';
import clsx from 'clsx';

import { tokens } from '../../../../theme/generated/tokens';
import { mergeSx } from '../../../../utils';
import { classNamesFor } from '../../../../utils/classNames';
import { markerSizeToWidth } from '../constants';
import { MarkerProps } from '../types';

const factory = classNamesFor('StripMarker');

export const stripMarkerClassNames = {
  root: factory.root(),
};

export const StripMarker = ({
  className,
  color = tokens.primitives.colors.green[300],
  size: _size = 'm',
}: MarkerProps) => {
  const size = markerSizeToWidth[_size];
  return (
    <Box
      className={clsx(stripMarkerClassNames.root, className)}
      sx={mergeSx({
        borderRadius: tokens.theme.radius.xs,
        backgroundColor: color,
        minWidth: size,
        width: size,
        maxWidth: size,
        alignSelf: 'stretch',
        height: '100%',
      })}
    />
  );
};
